import * as React from "react";
import { SurveyStep, Question, Answer } from "../types";

interface DispatchProps {
  goToCovidStep: (step: SurveyStep) => void;
  processQuestion: (question: Question) => void;
}

interface StoreProps {
  question: Question;
}

interface OwnState {
  submitDisabled: boolean;
  selectedAnswer: Answer | null;
}

type Props = StoreProps & DispatchProps;

class AnswerQuestion extends React.PureComponent<Props, OwnState> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public continueButton: any;

  public constructor(props: Props) {
    super(props);

    this.state = {
      submitDisabled: true,
      selectedAnswer: null
    };

    this.submitQuestion = this.submitQuestion.bind(this);
  }

  private selectAnswer = (answer: Answer) => {
    this.setState({ selectedAnswer: answer, submitDisabled: false });
  };

  private submitQuestion = (answer: Answer) => {
    this.props.question.SelectedAnswer = answer;
    this.props.processQuestion(this.props.question);
    this.setState({ selectedAnswer: answer, submitDisabled: false });
  };

  public render() {
    return (
      <>
        <div key={this.props.question.Id} className="position-absolute">
          <div className="question">{this.props.question.Question}</div>
          <div className="lineitems">
            {this.props.question.LineItems &&
              this.props.question.LineItems.map(m => (
                <div className="lineitem" key={m}>
                  {m}
                </div>
              ))}
          </div>
          <div className="body white">
            <div className="answers">
              {this.props.question.Answers.map(a => {
                return (
                  <button onClick={() => this.submitQuestion(a)} key={a.Answer}>
                    {a.Answer}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default AnswerQuestion;
